var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlide2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Maintien_et_retour_en_emploi_re\\u0301ussi",
    "data-name": "Maintien et retour en emploi re\\u0301ussi",
    xmlns: "http://www.w3.org/2000/svg",
    width: 223.64,
    height: 181.397,
    viewBox: "0 0 223.64 181.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_444",
    "data-name": "Trac\\xE9 444",
    d: "M342.493,668.895a229.188,229.188,0,0,1-31.125-2.039c-.337-.043-.678-.091-1.017-.142-2.532-.36-5.066-.772-7.529-1.224a162.622,162.622,0,0,1-31.067-8.8C240.04,644,220.1,646.7,208.956,651.2c-12.059,4.869-16.695,12.835-16.74,12.915l-.4-.225c.046-.081,4.741-8.166,16.933-13.1,7.148-2.892,15.44-4.156,24.648-3.758,11.494.5,24.456,3.6,38.525,9.231a162.184,162.184,0,0,0,30.98,8.775c2.457.451,4.985.861,7.513,1.221.338.05.676.1,1.012.141,27.965,3.847,54.943,1.527,72.651-1.1a232.985,232.985,0,0,0,24.082-4.715l.119.44a233.324,233.324,0,0,1-24.135,4.727,287.576,287.576,0,0,1-41.653,3.137Z",
    transform: "translate(-191.819 -502.307)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_445",
    "data-name": "Trac\\xE9 445",
    d: "M342.524,191.041c-8.04,0-15.868-.376-23.42-1.128a174.086,174.086,0,0,1-47.35-11.083c-31.715-12.686-51.656-9.986-62.8-5.487-12.059,4.869-16.695,12.834-16.74,12.914l-.4-.225c.046-.081,4.741-8.165,16.933-13.1a58.683,58.683,0,0,1,24.648-3.758c11.494.5,24.456,3.6,38.525,9.231,31.765,12.706,67.112,13.205,91.171,11.388a269.528,269.528,0,0,0,45.067-7.063l.119.44a269.941,269.941,0,0,1-45.142,7.077C356.146,190.777,349.26,191.041,342.524,191.041Z",
    transform: "translate(-191.819 -155.355)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_446",
    "data-name": "Trac\\xE9 446",
    d: "M659.548,121.125s-8.967-3.2-14.731,9.607a252.607,252.607,0,0,1-14.731,26.9l5.124,1.281s1.281-8.967,4.483-10.248l-1.281,11.529s38.428,13.45,55.721-1.281l-.64-4.483s2.562.64,2.562,4.483l1.921-1.921s-1.921-3.843-7.686-8.967c-3.783-3.363-5.084-9.761-5.53-13.761a16.653,16.653,0,0,0-3.834-9.069C677.1,120.755,670.116,116.036,659.548,121.125Z",
    transform: "translate(-510.024 -118.919)",
    fill: "#2f0d38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_447",
    "data-name": "Trac\\xE9 447",
    d: "M875.081,391.56s16.873,14.392,19.355,22.829-9.429,9.429-9.429,9.429L859.2,426.3s-.5,11.911-4.963,13.4-.907-19.7-.907-19.7l25.224-7.1L867.14,400.989Z",
    transform: "translate(-671.135 -316.871)",
    fill: "#fcb5a4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_448",
    "data-name": "Trac\\xE9 448",
    d: "M601.1,445.907l-1.985,26.3-10.918,44.665s-9.926,20.347-1.489,20.844,7.94-19.355,7.94-19.355l15.881-42.183,1.489-28.784Z",
    transform: "translate(-476.059 -356.33)",
    fill: "#fcb5a4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 16.377,
    cy: 16.377,
    r: 16.377,
    transform: "translate(136.452 10.67)",
    fill: "#fcb5a4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_449",
    "data-name": "Trac\\xE9 449",
    d: "M708.9,246.635s5.955,21.34-3.474,26.8,23.821,9.429,32.754-6.948c0,0-15.881-5.459-11.414-19.851Z",
    transform: "translate(-563.513 -211.647)",
    fill: "#fcb5a4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_450",
    "data-name": "Trac\\xE9 450",
    d: "M654.552,350.887l-2.978-.993s-5.955,2.481-5.955,6.948-.993,22.332-.993,22.332l13.4,1.489Z",
    transform: "translate(-520.581 -286.619)",
    fill: "#c3e5ea"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_451",
    "data-name": "Trac\\xE9 451",
    d: "M701.035,593.12c-18.32,2.714-45.022,4.906-72.714,1.1,0-.274,0-.541,0-.8q0-2.323.178-4.593c1.419-18.637,11.02-34.175,14.735-39.56.187-.274.36-.52.515-.739.6-.842.949-1.286.949-1.286s28.784-.47,43.672,5.485a6.4,6.4,0,0,1,1.939,1.268C695.858,559.114,699.12,575.744,701.035,593.12Z",
    transform: "translate(-508.741 -429.895)",
    fill: "#2f0d38"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_452",
    "data-name": "Trac\\xE9 452",
    d: "M846.876,326.01s6.452-3.474,12.9,3.97l12.9,14.888-9.925,10.918L843.9,344.372Z",
    transform: "translate(-665.263 -268.69)",
    fill: "#c3e5ea"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_453",
    "data-name": "Trac\\xE9 453",
    d: "M683.531,166.331c5.8-4.2,10.491-9.029,13.6-14.777,0,0,10.64,11.822,17.142,12.413s.591-14.186.591-14.186l-11.822-2.955-11.231,1.182-8.866,5.911Z",
    transform: "translate(-548.399 -139.181)",
    fill: "#2f0d38"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_454",
    "data-name": "Trac\\xE9 454",
    d: "M711.179,315.474s-6.945,10.981-27.79,5.739l-11.829,3.258-1.572.433s1.489,29.776,5.459,35.235,2.978,8.437,1.985,8.933-3.474-.5-1.985,1.985,3.474.993,1.489,2.481-2.978,6.948-2.978,6.948l46.65,5.955s-1.489-19.355,2.481-29.28a127.873,127.873,0,0,0,4.963-13.9l-2.978-24.814Z",
    transform: "translate(-538.995 -261.629)",
    fill: "#c3e5ea"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8074",
    "data-name": "Rectangle 8074",
    width: 63.858,
    height: 79.822,
    transform: "translate(11.373 44.13)",
    fill: "#c9d2df"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8075",
    "data-name": "Rectangle 8075",
    width: 13.684,
    height: 9.123,
    transform: "translate(15.821 50.858)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8076",
    "data-name": "Rectangle 8076",
    width: 52.911,
    height: 3.193,
    transform: "translate(15.935 68.647)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8077",
    "data-name": "Rectangle 8077",
    width: 52.911,
    height: 3.193,
    transform: "translate(15.935 77.086)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8078",
    "data-name": "Rectangle 8078",
    width: 52.911,
    height: 3.193,
    transform: "translate(15.935 85.524)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8079",
    "data-name": "Rectangle 8079",
    width: 52.911,
    height: 3.193,
    transform: "translate(15.935 93.962)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8080",
    "data-name": "Rectangle 8080",
    width: 52.911,
    height: 3.193,
    transform: "translate(15.935 102.401)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_455",
    "data-name": "Trac\\xE9 455",
    d: "M445.919,537.785a12.508,12.508,0,1,1-1.939-6.7A12.508,12.508,0,0,1,445.919,537.785Z",
    transform: "translate(-358.144 -413.946)",
    fill: "#31AFB4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_456",
    "data-name": "Trac\\xE9 456",
    d: "M458.91,541.562l-12.347,12.345c-.776-1.2-5.1-6.785-5.1-6.785a17.5,17.5,0,0,1,1.77-1.562l3.585,4.78,10.646-10.646A12.5,12.5,0,0,1,458.91,541.562Z",
    transform: "translate(-373.074 -424.424)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide2);
export default __webpack_public_path__ + "static/media/slide2.469449277730d59b7b933dd6ad2cdfbd.svg";
export { ForwardRef as ReactComponent };